import { escapeRegex } from "@citychallenge/common";
import { observable, action, computed } from "mobx";
import { debounce } from "@citychallenge/common";
import { OnDemandPlaylistModel } from "./on-demand-playlist.model";

export class OnDemandStore {
  @observable
  public playlists: OnDemandPlaylistModel[];

  @action
  public setPlaylists(playlists: OnDemandPlaylistModel[]) {
    this.playlists = playlists;
  }

  constructor(playlists: OnDemandPlaylistModel[] = []) {
    this.playlists = playlists;
  }

  public findById(playlistId: string) {
    return this.playlists.find(({ id }) => {
      return id === playlistId;
    });
  }

  @observable
  public searchFilter = "";

  @action
  public setSearchFilter = (value: string) => {
    this.searchFilter = value;
  };

  public setSearchFilterDebounced = debounce(this.setSearchFilter, 300);

  public resetSearchFilter = () => {
    this.setSearchFilter("");
  };

  @computed
  public get filteredPlaylists() {
    const { playlists } = this;

    if (this.searchFilter.length) {
      const regex = new RegExp(escapeRegex(this.searchFilter), "i");
      return playlists.filter((playlist) => regex.test(playlist.name));
    }

    return this.playlists;
  }
}
